import {
  clearCreateGroup,
  getAllAmenitiesRateTypes,
  getAllAmenityTypes,
} from "../../../Redux/Groups/GroupsActions";
import GroupInformation from "../../../Components/Admin/Groups/GroupInformation/GroupInformation";
import Amenities from "../../../Components/Admin/Groups/Amenities/Amenities";
import Packages from "../../../Components/Admin/Groups/Packages/Packages";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import React, { useEffect, useState } from "react";
import styles from "./AddGroup.module.scss";
import { Link } from "react-router";

function AddGroup() {
  const [activeTab, setActiveTab] = useState("groupInformation");
  const dispatch = useDispatch<AppDispatch>();
  const { profileLoading } = useSelector((state: RootState) => state.profile);
  const { createGroupData } = useSelector((state: RootState) => state.groups);

  const tabs = [
    {
      label: "Group Information",
      value: "groupInformation",
    },
    {
      label: "Amenities",
      value: "amenities",
    },
    {
      label: "Packages",
      value: "packages",
    },
  ];
  const tabsRenderer = () => {
    return (
      <React.Fragment>
        <div className={styles.tabsContainer}>
          {tabs.map((tab, i) => (
            <div
              key={i}
              className={
                activeTab === tab.value ? styles.activeTab : styles.tab
              }
            >
              <p>{tab.label}</p>
            </div>
          ))}
        </div>
        <div className={styles.tabContent}>
          {activeTab === "groupInformation" && (
            <GroupInformation
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              groupId={createGroupData?.id || ""}
            />
          )}
          {activeTab === "amenities" && (
            <Amenities
              setActiveTab={setActiveTab}
              groupId={createGroupData?.id || ""}
            />
          )}
          {activeTab === "packages" && (
            <Packages
              setActiveTab={setActiveTab}
              groupId={createGroupData?.id || ""}
            />
          )}
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    // dispatch(getProfile());
    dispatch(getAllAmenitiesRateTypes());
    dispatch(getAllAmenityTypes());
    return () => {
      dispatch(clearCreateGroup());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (profileLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/groups" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Groups
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <p className={styles.heading}>Add Group</p>
      </div>
      <div className={styles.bodyContainer}>
        <div className={styles.tabsContainer}>{tabsRenderer()}</div>
      </div>
    </div>
  );
}

export default AddGroup;
